export const TASK_CREATE_A_VIEW = 'create-a-view';
export const TASK_CREATE_IDEAS = 'create-ideas';
export const TASK_EXPLORE_THE_BASICS = 'explore-the-basics';
export const TASK_PRIORITIZE_AND_PLAN = 'prioritize-and-plan';
export const TASK_SHARE_AND_COLLABORATE = 'share-and-collaborate';
export const TASK_LINK_WORK_ITEMS = 'link-work-items';

export type TaskId =
	| typeof TASK_CREATE_A_VIEW
	| typeof TASK_CREATE_IDEAS
	| typeof TASK_EXPLORE_THE_BASICS
	| typeof TASK_PRIORITIZE_AND_PLAN
	| typeof TASK_SHARE_AND_COLLABORATE
	| typeof TASK_LINK_WORK_ITEMS;
